import { ChromeVideoEngine } from './ChromeVideoEngine';
import { StandardVideoEngine } from './StandardVideoEngine';
export function createVideoEngine() {
    // On chrome MediaStreamTrackProcessor in window object
    if (typeof MediaStreamTrackProcessor !== 'undefined') {
        return new ChromeVideoEngine();
    }
    return new StandardVideoEngine();
}
